import React, { useState } from 'react'

import {
  Box,
  Button,
  Container,
  IconButton,
  Typography,
} from '@material-ui/core'
import { ArrowBack } from '@material-ui/icons'
import { Folder, Video, Clock, Play, Award } from 'react-feather'
import clsx from 'clsx'

import useStyles from './styles'

const InfoRow = ({ icon: Icon, label, value, classes }) => (
  <Box className={classes.infoRow}>
    <Box className={classes.infoIconWrapper}>
      <Icon size={18} className={classes.infoIcon} />
    </Box>
    <Box className={classes.infoTextBlock}>
      <Typography className={classes.infoLabel}>{label}</Typography>
      <Typography className={classes.infoValue}>{value}</Typography>
    </Box>
  </Box>
)

const CourseHeader = ({ course, modules, onBack, onStart, onCertificate }) => {
  const classes = useStyles()
  const [descriptionExpanded, setDescriptionExpanded] = useState(false)

  const modulesCount = course?.modulesCount ?? modules?.length ?? 0
  const lessonsCount = course?.lessonsCount ?? 0
  const totalDuration = course?.totalDuration ?? 0
  const hasProgress = (course?.progress ?? 0) > 0
  const isCompleted = course?.completed ?? false

  return (
    <Box className={classes.root}>
      <Container maxWidth="lg">
        <Box className={classes.backRow} onClick={onBack}>
          <IconButton className={classes.backButton} size="small">
            <ArrowBack fontSize="small" />
          </IconButton>
          <Typography className={classes.backLabel}>Voltar</Typography>
        </Box>

        <Box className={classes.inner}>
          <Box className={classes.content}>
            <Typography className={classes.title}>{course?.title}</Typography>
            {course?.description && (
              <>
                <Typography
                  className={clsx(classes.description, {
                    [classes.descriptionClamped]: !descriptionExpanded,
                  })}
                >
                  {course.description}
                </Typography>
                <button
                  className={classes.descriptionToggle}
                  onClick={() =>
                    setDescriptionExpanded((previous) => !previous)
                  }
                >
                  {descriptionExpanded ? 'Ver menos' : 'Ver mais'}
                </button>
              </>
            )}
          </Box>

          <Box className={classes.infoCard}>
            <InfoRow
              icon={Folder}
              label="Módulos"
              value={modulesCount}
              classes={classes}
            />
            <InfoRow
              icon={Video}
              label="Aulas"
              value={lessonsCount}
              classes={classes}
            />
            <InfoRow
              icon={Clock}
              label="Duração Total"
              value={totalDuration}
              classes={classes}
            />

            <Box className={classes.divider} />

            {isCompleted ? (
              <Button
                variant="contained"
                fullWidth
                disableElevation
                className={classes.certificateButton}
                startIcon={<Award size={16} />}
                onClick={onCertificate}
              >
                VER CERTIFICADO
              </Button>
            ) : (
              <Button
                variant="contained"
                fullWidth
                disableElevation
                className={classes.startButton}
                startIcon={<Play size={16} />}
                onClick={onStart}
              >
                {hasProgress ? 'CONTINUAR CURSO' : 'INICIAR CURSO'}
              </Button>
            )}
          </Box>
        </Box>
      </Container>
    </Box>
  )
}

export default CourseHeader
